import { createSelector } from "reselect";

const authUserPersonalId = ({ auth }) => auth.authUserPersonalId;

export const selectPersonalId = createSelector(
  [authUserPersonalId],
  (authUserPersonalId) =>
    authUserPersonalId?.data?.attributes?.social_security_number,
);
